// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBanner_container__2K9GT","center_container":"ErrorBanner_center_container__3iVsQ","close":"ErrorBanner_close__1C8nq"};